import React, { useState, useEffect } from "react";
import { MDBDataTableV5 } from 'mdbreact';
import SuperadminSidebar from "../Layout/SuperadminSidebar";
import Navbar from "../Layout/Navbar";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";

export default function SubscribeUsers() {
  const [datatable, setDatatable] = React.useState();
  const host = APIModel.HOST;
  let token = localStorage.getItem("Token");

  useEffect(async () => {
    await axios.get(host + "get-subscribe-users/", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setDatatable({
            columns: [
             {
                label: 'ID',
                field: 'id',
                width: 20,
             },
             {
                label: 'Subscribe ID',
                field: 'sub_id',
                width: 100,
             },
             {
                label: 'Subscrib Package',
                field: 'sub_type',
                width: 100,
             },
              {
                label: 'Name',
                field: 'name',
                width: 200,
                attributes: {
                  'aria-controls': 'DataTable',
                  'aria-label': 'Name',
                },
              },
              {
                label: 'Email',
                field: 'email',
                width: 300,
              },
              {
                label: 'Industry',
                field: 'industry',
                width: 200,
              },
              {
                label: 'Status',
                field: 'status',
                width: 200,
              },
              {
                label: 'Created At',
                field: 'created_at',
                width: 200,
              },
            ],
            rows: response.data.data,
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <div className="wrapper">
        <SuperadminSidebar />
        <Navbar />
        <div className="main-panel">
            <div className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header theme-color">
                            <h3>Subscribe Users List</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <MDBDataTableV5 hover entriesOptions={[5, 20, 25]} entries={5} pagesAmount={4} data={datatable} searchTop searchBottom={false} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}